const Helpers = {
    formatPrice: (ammount) => {
        ammount = ammount.toString();
        // if (!ammount.includes('.')) ammount += '00';
        const ammountFloatString = ammount.substring(0, ammount.length - 2)+"."+ammount.substring(ammount.length - 2);
        const newAmmountString = Intl.NumberFormat(Shopify.locale, {
            style: 'currency',
            currency: Shopify.currency.active
            }).format(ammountFloatString);
        return newAmmountString;
    },

    formatFloatPrice: (ammount) => {
        ammount = ammount.toString();
        const newAmmountString = Intl.NumberFormat(Shopify.locale, {
            style: 'currency',
            currency: Shopify.currency.active
            }).format(ammount);
        return newAmmountString;
    }
}
